<template>
  <div class="flex flex-col">
    <span class="text-[0.65rem] uppercase text-neutral-400">
      <font-awesome-icon v-if="titleIcon" :icon="[titleIcon.type, titleIcon.name]" class="mr-1" />
      {{ title }}
      <InfuseTooltip
        v-if="help"
        :title="title"
        :content="help"
        :icon="[titleIcon?.type || 'far', titleIcon?.name || 'help']"
        class="inline-block cursor-help normal-case text-primary-500"
        offset-distance="4"
      >
        <font-awesome-icon :icon="['fal', 'circle-info']" class="ml-1" />
      </InfuseTooltip>
    </span>
    <div v-if="!loading" class="flex flex-row">
      <slot />
    </div>
    <div v-else class="skeleton flex w-24 flex-col">&nbsp;</div>
  </div>
</template>

<script setup lang="ts">
import { InfuseTooltip } from '@infuse/ui/components';

interface Props {
  title: string;
  titleIcon?: {
    type: 'fal' | 'far' | 'fas';
    name: string;
  };
  help?: string;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  title: '',
  titleIcon: undefined,
  help: undefined
});
</script>
